import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["toggle", "checkbox"]

  toggleAll() {
    const checked = this.toggleTarget.checked
    this.checkboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
  }

  updateToggle() {
    const total = this.checkboxTargets.length
    const checkedCount = this.checkboxTargets.filter(cb => cb.checked).length
    this.toggleTarget.checked = total > 0 && checkedCount === total
    this.toggleTarget.indeterminate = checkedCount > 0 && checkedCount < total
  }
}
